<template>
  <div class="page-content" id="patrol-list">
    <Titlebar :incrustation="'fa-history'">
      <h1>{{ $t('patrol.titles.listing') }}</h1>
    </Titlebar>


    <div class="scroll">
      <div class="container">
        <div class="row">
          <div class="col col-xl-12 mt-3">
            <SuperTable ref="tablePatrols" :tableColumns="tableColumns" :tableData="tableData"
                        @sort="handleSort" @filter="handleFilter" @delete="handleDelete"
                        @copy="handleCopy">
            </SuperTable>
          </div>
        </div>
      </div>
    </div>
    <Toolbar>
      <div class="row">
        <div class="col">
          <Btn :class="['default pull-left']" :disabled="tableData.length==0"
               v-if="useDvFlagAccess('beepiz-patrols-can:export')" @click.native="dlReport">
            <i class="fa fa-file-excel-o"></i> {{ $t('patrol.btns.printXLS') }}
          </Btn>
        </div>
        <div class="col center">
          <Pagination ref="pagination" @change="handlePagination"></Pagination>
        </div>
        <div class="col">
        </div>
      </div>
    </Toolbar>
    <LoadingMini ref="loading"></LoadingMini>

    <!--</div>-->
  </div>
</template>

<script>
import axios from 'axios';
import API from '@/services/API.js';
import Auth from '@/services/auth.js'
import Utils from '@/services/utils.js'
import Titlebar from "@/components/ui/Titlebar";
import Toolbar from "@/components/ui/Toolbar";
import Btn from "@/components/ui/Button";
import Pagination from "@/components/ui/Pagination";
import SuperTable from "@/components/ui/Table";
import Globals from '@/services/globals.js';

import LoadingMini from '@/components/ui/LoadingMini';

import moment from "moment";
import {useDvFlagAccess} from "../../services/featureFlag";

export default {
  name: 'PatrolsListing',
  components: {
    Titlebar,
    Toolbar,
    Btn,
    Pagination,
    SuperTable,
    LoadingMini
  },
  computed: {
    constructReportFileName: function () {
      var name = Utils.t('patrol.recent.reportName');
      console.log('REPORT NAME', Utils.sanitize(name, true))
      return Utils.sanitize(name, true);
    },
  },
  data: () => ({
    count: 0,
    config: {
      perpage: Globals.perPage,
      fields: [],
      page: 1,
      filter: {
        like: [],
        equals: []
      },
      sort: ['-start_date']
    },
    tableColumns: {
      global: {
        sortable: false,
        noItemsMsg: window.V.$i18n.t('patrol.emptyTable')
      },
      columns: [
        {
          key: 'id',
          label: Utils.t('patrol.id'),
          showPopup: false,
          activeFilter: '',
          activeSort: '',
          sortable: true,
          filter: false,
          width: '15%',
          className: '',
          renderer: function (item) {
            if (item.start_date) {
              let date = moment(item.start_date.date)

              let temp = Utils.pad((date.valueOf() / 1000).toString(), '0', 12)
              let temp2 = []
              for (var i = 0; i < temp.length; i += 3) {
                temp2.push(temp.substr(i, 3))
              }
              return temp2.join('-')
            }
            return ''
          }
        },
        {
          key: 'patrol_name',
          label: Utils.t('patrol.name'),
          showPopup: false,
          activeFilter: '',
          activeSort: false,
          sortable: true,
          filter: {
            type: 'text'
          },
          width: '20%',
          className: 'bold',
          renderer: function (item) {
            if (item.first_scan_date) {
              let date = moment(item.first_scan_date.date)

              let link = '/#/patrols/compare?patrolid=' + item.patrol_id
              if (item.identification_id) {
                link += '&resourcetype=identification&resourceid=' + item.identification_id
              } else {
                link += '&resourcetype=dati&resourceid=' + item.dati_id
              }
              link += '&date=' + date.format('YYYY-MM-DD') + '&time=' + date.format('HH:mm:ss')
              return useDvFlagAccess('beepiz-patrols-can:update') ? '<a href="' + link + '">' + item.patrol_name + '</a>' : item.patrol_name
            }
            return item.patrol_name
          }
        },
        {
          key: 'waiting_checkpoints',
          label: Utils.t('patrol.checkpointCount'),
          showPopup: false,
          activeFilter: '',
          activeSort: false,
          sortable: true,
          filter: false,
          width: '5%',
          className: 'center-align'
        },
        {
          key: 'scanned_checkpoints',
          label: Utils.t('patrol.checkpointsCompleted'),
          showPopup: false,
          activeFilter: '',
          activeSort: false,
          sortable: true,
          filter: false,
          width: '5%',
          className: 'center-align',
        },
        {
          key: 'dati_name',
          label: Utils.t('patrol.datiName'),
          showPopup: false,
          activeFilter: '',
          activeSort: false,
          sortable: true,
          filter: {
            type: 'text'
          },
          width: '15%',
          className: ''
        },
        {
          key: 'identification_name',
          label: Utils.t('patrol.identificationName'),
          showPopup: false,
          activeFilter: '',
          activeSort: false,
          sortable: true,
          filter: {
            type: 'text'
          },
          width: '10%',
          className: 'center-align'
        },
        {
          key: 'start_date',
          label: Utils.t('patrol.firstScannedDate'),
          showPopup: false,
          activeFilter: '',
          activeSort: '-',
          sortable: true,
          filter: {
            type: 'text'
          },
          width: '15%',
          className: '',
          renderer: function (item) {
            if (item.start_date !== null) {
              let arrayOfDate = moment.tz(item.start_date.date, item.start_date.timezone).local();
              let formattedDate = arrayOfDate._i;
              formattedDate = formattedDate.substring(0, 19);
              let date = new Date(formattedDate);
              return date.toLocaleString()
            } else {
              return ""
            }
          }
        },
      ],
      rowActions: {
        width: '15%'
      }
    },
    tableData: []
  }),

  methods: {
    useDvFlagAccess,
    handlePagination: function (page) {
      this.config.page = page;
      this.loadData();
    },
    handleSort: function () {
      this.config.sort = [];
      for (var colKey in this.tableColumns.columns) {
        var col = this.tableColumns.columns[colKey];
        if (col.activeSort) {
          this.config.sort.push(col.activeSort + col.key);
        }
      }
      this.loadData();
    },
    handleFilter: function () {
      this.config.page = 1;
      this.config.filter.like = [];
      this.config.filter.equals = [];
      for (var colKey in this.tableColumns.columns) {
        var col = this.tableColumns.columns[colKey];
        if (col.activeFilter !== '') {
          if (col.filter && col.filter.type == 'text') {
            let filterValue = col.activeFilter
            if (col.key == 'start_date') {
              filterValue = moment(col.activeFilter, 'DD/MM/YYYY').format('YYYY-MM-DD')
            }
            this.config.filter.like.push(col.key + ':' + filterValue);
          }
          if (col.filter && col.filter.type == 'list') {
            this.config.filter.equals.push(col.key + ':' + col.activeFilter);
          }
        }
      }
      this.loadData();
    },
    handleCopy: function (item) {
      window.V._router.push('/patrols/' + item.id + '/copy');
    },
    handleDelete: function (item) {
      window.Vfc.$refs.confirm.show({
        title: Utils.t('global.deleteModalTitle'),
        content: Utils.t('global.deleteModalContent'),
        callbackYes: () => {
          axios.delete(API.route(API.endpoints.patrols.delete, {patrolId: item.id}))
              .then(response => {
                if (this.tableData.length == 1 && this.config.page > 1) {
                  this.config.page--;
                }
                this.loadData();
              })
              .catch(e => {
                this.$refs.loading.hide();
              });
        }
      });
    },
    loadData: function () {
      if (this.$refs.loading) {
        this.$refs.loading.show();
      }

      axios.get(API.endpoints.patrols.listing + API.constructQueryParams(this.config))
          .then(response => {
            this.tableData = response.data.data;
            this.count = response.data.meta.pagination.total;
            this.$refs.pagination.update(response.data.meta.pagination);
          })
          .catch(e => {
          }).finally(f => {
            if (this.$refs.loading) {
              this.$refs.loading.hide();
            }
          }
      )
    },

    dlReport: function () {

      const outputFormat = 'xls';
      var route = API.endpoints.patrols.listingExport;

      var apiRoute = API.route(route);

      axios.get(apiRoute, {
        responseType: 'blob',
        headers: {
          'Accept': Utils.getMimeFromOutput(outputFormat)

        }

      })
          .then(response => {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            var newBlob = new Blob([response.data], {type: Utils.getMimeFromOutput(outputFormat)})

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob, this.constructReportFileName + "." + outputFormat);
              return;
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            var now = moment().format('YYYYMMDD_HHmm');
            document.body.appendChild(link);
            link.href = data;
            link.download = this.constructReportFileName + '_' + now + "." + outputFormat;
            link.click();
            setTimeout(function () {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(data);
            }, 100)

          })

    }

  },

  watch: {
    tableData: {
      handler: function (val) {
      }
    }
  },

  mounted() {
    if (!useDvFlagAccess('beepiz-patrols-can:read')) {
      this.$router.push({name: 'AccessDenied', params: {slug: 'patrols'}})
    } else {
      if (!useDvFlagAccess('beepiz-patrols-can:delete')) {
        this.tableColumns.rowActions.actions.splice(1, 1);
      }

      if (!useDvFlagAccess('beepiz-patrols-can:create')) {
        this.tableColumns.rowActions.actions.splice(0, 1);
      }

      this.loadData(1);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
